export default "__VITE_ASSET__EuycQ40S__"